import { useId, useState } from 'react';
import type { ChipStatus as ChipStatusProps } from '../../api/tipos.js';

const COR_POR_STATUS: Record<ChipStatusProps['status'], string> = {
  Verde: 'bg-status-verde/15 text-status-verde border-status-verde/30',
  Amarelo: 'bg-status-ambar/15 text-status-ambar border-status-ambar/30',
  Vermelho: 'bg-status-vermelho/15 text-status-vermelho border-status-vermelho/30',
};

// SPEC-UX §3.4: chip com tooltip obrigatório (fórmula, fonte, valor vs
// meta, frescor). Fora da janela de frescor: amarelo com badge "dado de N
// dias". NUNCA clicável para edição — I9 na interface.
export function ChipStatus({ status, formula, fonte, valor, meta, fresco, calculadoEm }: ChipStatusProps) {
  const [aberto, setAberto] = useState(false);
  const idTooltip = useId();

  const statusEfetivo = fresco ? status : 'Amarelo';
  const diasAtras = Math.floor((Date.now() - new Date(calculadoEm).getTime()) / 86_400_000);

  return (
    <span className="relative inline-flex">
      <button
        type="button"
        aria-describedby={idTooltip}
        onFocus={() => setAberto(true)}
        onBlur={() => setAberto(false)}
        onMouseEnter={() => setAberto(true)}
        onMouseLeave={() => setAberto(false)}
        className={`inline-flex cursor-default items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium ${COR_POR_STATUS[statusEfetivo]}`}
      >
        {statusEfetivo}
        {!fresco && <span className="fonte-mono text-[10px] opacity-80">· dado de {diasAtras}d</span>}
      </button>
      {aberto && (
        <div
          id={idTooltip}
          role="tooltip"
          className="absolute left-0 top-full z-10 mt-1 w-56 rounded border border-borda bg-superficie p-2 text-xs text-ink shadow-lg"
        >
          <p className="fonte-mono">
            {valor} / meta {meta}
          </p>
          <p className="mt-1 text-grafite">{formula}</p>
          <p className="mt-1 text-grafite">Fonte: {fonte}</p>
          <p className="mt-1 text-grafite">Calculado há {diasAtras}d</p>
        </div>
      )}
    </span>
  );
}
